// src/index.ts
import { createAtom } from "mobx";
import { $$TARGET } from "@marvelapp/crdt";
var proxyOptions = {
  defaultCtx: {},
  onCreate: (target, parentKey, ctx) => {
    const atom = createAtom(parentKey);
    ctx.atom = atom;
    const yObject = target[$$TARGET];
    yObject == null ? void 0 : yObject.observe(() => atom.reportChanged());
  },
  onRead: (_target, _key, ctx) => {
    var _a;
    (_a = ctx.atom) == null ? void 0 : _a.reportObserved();
  }
};
export {
  proxyOptions
};
